module.exports = __webpack_public_path__ + "static/media/roundtrip.58e63023.svg";